import { css } from 'styled-components'

export default css`
  &.AddressAutocomplete {
    position: relative;

    .suggestions {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      z-index: 10;
      margin-top: 4px;
      padding: 4px 0;
      background: #ffffff;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      list-style: none;
    }

    .suggestion {
      padding: 8px 12px;
      cursor: pointer;
      font-size: 14px;

      &:hover,
      &.active {
        background: #f1f5f9;
      }
    }

    .suggestions-loading {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      z-index: 10;
      margin-top: 4px;
      padding: 8px 12px;
      background: #ffffff;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #6b7280;
    }
  }
`
